var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9478 20.9425C21.7993 20.9425 23.2982 19.4437 23.2982 17.5922C23.2982 15.7407 21.7993 14.2418 19.9478 14.2418C19.9363 14.2418 19.9248 14.2418 19.9133 14.2418C19.6182 11.5777 17.3527 9.5 14.6003 9.5C12.4268 9.5 10.56 10.7957 9.72433 12.6548C9.6975 12.6548 9.67067 12.651 9.64383 12.651C7.35533 12.651 5.5 14.5063 5.5 16.7948C5.5 19.0833 7.35533 20.9387 9.64383 20.9387",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0803 20.9397C21.8702 20.8702 23.298 19.3991 23.298 17.592C23.298 15.7405 21.7992 14.2416 19.9477 14.2416H19.9132C19.9028 14.1484 19.8901 14.0559 19.875 13.9641C20.2421 13.8263 20.6399 13.751 21.0554 13.751C22.7804 13.751 24.2026 15.0543 24.3904 16.7333H24.4134C25.5749 16.7333 26.5179 17.6763 26.5179 18.8378C26.5179 19.9993 25.5749 20.9423 24.4134 20.9423L20.0803 20.9397Z",
    fill: "#CAD1E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.5H19",
    stroke: "#CAD1E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22H21",
    stroke: "#CAD1E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23.5H19",
    stroke: "#CAD1E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/mist.6bd9cacee759fc88e20cc1b3dc2b31b4.svg";
export { ForwardRef as ReactComponent };